export enum MouseButtons {
    left = 1,
    middle = 2,
    right = 3,
  }